var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackerAcceptedCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-617 -4428) translate(-3826 31)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#94c83d",
    transform: "translate(4443 4397)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19-201v20.7H1.9V-201zm-.9.9H2.8v18.9h15.3zm-2.25 3.15v.9H5.05v-.9zm0 6.3v.9h-6.3v-.9zm-8.55 0v.9H5.05v-.9zm8.55 2.7v.9h-6.3v-.9zm-8.55 0v.9H5.05v-.9zm8.55 2.7v.9h-6.3v-.9zm-8.55 0v.9H5.05v-.9z",
    transform: "translate(-617 -4428) translate(628.1 4641)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackerAcceptedCurrent);
export default __webpack_public_path__ + "static/media/tracker-accepted-current.9db0f5522cf60ab312a7cbe1514fe3b3.svg";
export { ForwardRef as ReactComponent };